import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import routes from '../routes';
import { reactLocalStorage } from 'reactjs-localstorage';
import { configure } from 'axios-hooks';
import LRU from 'lru-cache';
import Axios from 'axios';
import { navigate } from 'raviger';
import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import ReactGA from 'react-ga'
import { I18nContextProvider } from '../i18n';
import 'react-datepicker/dist/react-datepicker.css';
import { ProgramProvider } from '../providers/programProvider';
import { AlertTemplate } from 'components'
import '../utils/extensions';
import moment from 'moment-timezone';

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
const cache = new LRU({ max: 10 });

axios.interceptors.request.use((config) => {
  const token = reactLocalStorage.get('token');
  config.headers['authtoken'] = token;
  config.headers['x-timezone'] = moment.tz.guess()

  return config;
});

axios.interceptors.response.use(
  (res) => {
    const oldToken = reactLocalStorage.get('token');
    const {
      headers: { token },
    } = res;

    //refresh the token
    if (token && oldToken !== token) {
      reactLocalStorage.set('token', token);
    }
    return Promise.resolve(res);
  },
  (err) => {
    if (err?.response?.status === 401) {
      reactLocalStorage.remove('user');
      reactLocalStorage.remove('token');
      //go to login
      window.location = '/login'
    }

    return Promise.reject(err);
  }
);

configure({ axios, cache });

// optional cofiguration
const options = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: '30px',
  // you can also just use 'scale'
  transition: transitions.SCALE,
};

const App = () => {
  const {
    REACT_APP_GA_TRACKING_ID
  } = process.env
  // Google Analytics Config
  if (REACT_APP_GA_TRACKING_ID) {
    ReactGA.initialize(REACT_APP_GA_TRACKING_ID)
    ReactGA.pageview(window.location.pathname + window.location.search)
  }

  return (
    <I18nContextProvider>
      <AlertProvider template={AlertTemplate} {...options}>
        <ProgramProvider>
          {routes()}
        </ProgramProvider>
      </AlertProvider>
    </I18nContextProvider>
  );
};

export default App;
